import Helmet from "react-helmet";
import { Text } from "../Type";
import Button from "../Button";
import styles from "./index.module.scss";

const PageNotFound = () => {
  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <div className={styles.content}>
      <Helmet>
        <title>Oops, Something went wrong</title>
      </Helmet>
      <Text className={styles.text} size="xlarge" weight="bold">
        Oops, page not found
      </Text>
      <Text>
        We couldn&apos;t find the page you are looking for.
        <Text>
        Sorry, the link you followed may be broken, or the page no longer exists.
        <Text size="small">
          Please{" "}
          <a
            href={`mailto:${process.env.REACT_APP_MOTION_SUPPORT_EMAIL}`}
            target="_blank"
            rel="noreferrer"
          >
            Contact a Motion rep
          </a>{" "}
          for help.
        </Text>
      </Text>

      </Text>
      <div className={styles.button}>
        <Button primary onClick={refreshPage}>
          Refresh page
        </Button>
      </div>
    </div>
  )
}

export default PageNotFound;
